import { plainAxiosInstance } from "../axios";

class SellersService {
  index(storeExternalId) {
    return plainAxiosInstance.get("/public/sellers", {
      params: { store_external_id: storeExternalId },
    });
  }
}

export default new SellersService();
